import { ChangeDetectionStrategy, Component, effect, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { CityConfigService } from '@app/core/services';
import { UserService } from '@app/core/services/user.service';
import { ThemeMainColorType, ThemingService } from '@cirklo/angular/theming';
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RouterOutlet],
})
export class AppComponent implements OnInit {
    private userService = inject(UserService);
    private cityConfigService = inject(CityConfigService);
    private themingService = inject(ThemingService);

    constructor() {
        effect(() => {
            const config = this.cityConfigService.configSignal();
            this.themingService.setupTheme({
                [ThemeMainColorType.PRIMARY]: config?.primaryColor,
                [ThemeMainColorType.ACCENT]: config?.accentColor,
            });
        });
    }

    async ngOnInit() {
        try {
            await this.userService.loadConnectedUser();
        } catch {
            // No need to do anything here, if not authenticated, guard redirects
        }
    }
}
